import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import { BUSINESS_TYPES } from '../constants';

const TypeItem = ({ icon, active, label, description, onClick }) => {
  return (
    <div
      className={cn(
        'border-2 border-gray-100 rounded-lg p-6 relative hover:border-primary-800 transition hover:bg-gray-50 hover:text-primary-800',
        active ? 'border-green-500 ring-2 ring-opacity-50 ring-green-500' : ''
      )}
    >
      <div className="space-y-3">
        <div className="flex justify-center">
          <div className="h-20 w-20 rounded-[15px] flex justify-center items-center bg-gradient-to-br from-white to-primary-50">
            {icon ? <img src={icon} className="h-12 w-12" alt="" /> : null}
          </div>
        </div>
        <div className="text-center text-lg font-bold">{label}</div>
        <div className="text-center">{description}</div>
      </div>
      {active ? (
        <div className="absolute top-0 right-0 p-3">
          <AiOutlineCheckCircle className="text-green-500 h-8 w-8" />
        </div>
      ) : null}
      <button
        className="absolute inset-0 z-10 h-full w-full"
        type="button"
        onClick={onClick}
      >
        <span className="sr-only">Choose {label}</span>
      </button>
    </div>
  );
};

TypeItem.defaultProps = {
  active: false,
  icon: '',
};

TypeItem.propTypes = {
  icon: PropTypes.string,
  active: PropTypes.bool,
  label: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

function BusinessTypeOptions({ disabled, name, onChange, value }) {
  const handleSelect = (newValue) => () => {
    if (disabled) return;
    onChange((state) => ({
      ...state,
      [name]: newValue,
    }));
  };
  return (
    <div className="grid grid-cols-2 gap-3">
      {BUSINESS_TYPES.map((item) => (
        <TypeItem
          key={item.code}
          label={item.name}
          description={item.description}
          icon={item.icon}
          onClick={handleSelect(item.code)}
          active={value === item.code}
        />
      ))}
    </div>
  );
}

BusinessTypeOptions.defaultProps = {
  value: '',
};

BusinessTypeOptions.propTypes = {
  disabled: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default BusinessTypeOptions;
